import React, { useEffect, useState, useRef, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const HeroSection = () => {
  const [showModal, setShowModal] = useState(false);
  return <>
      <section className="relative w-full bg-black min-h-[100vh] py-12 overflow-hidden" data-id="element-93">
        {/* Animated Gradient Background */}
        <div className="absolute inset-0 w-full h-full z-0 overflow-hidden" data-id="element-94">
          <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#0f0f0a] to-[#000000] animate-gradient-shift" data-id="element-95">
            <div className="absolute inset-0 opacity-30" data-id="element-96">
              <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_#ffdf07_0%,_transparent_60%)] animate-float-light-1" data-id="element-97"></div>
              <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(ellipse_at_bottom_left,_#D4AF37_0%,_transparent_60%)] animate-float-light-2" data-id="element-98"></div>
              <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-99"></div>
            </div>
          </div>
          <div className="absolute inset-0 bg-black bg-opacity-40 z-10" data-id="element-100"></div>
        </div>
        {/* Content */}
        <div className="relative z-20 w-full mx-auto py-8 px-4 sm:px-6 md:px-8 flex flex-col justify-center min-h-[90vh]" data-id="element-101">
          <div className="max-w-4xl mx-auto text-center" data-id="element-102">
            {/* Logo */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7
          }} className="mb-6" data-id="element-103">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEuzHiZoD7HHWbnpRvvh2M/516lion.png" alt="516 Partners Logo" className="mx-auto w-24 sm:w-28 md:w-32" data-id="element-104" />
            </motion.div>
            {/* Small Headline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.2
          }} className="text-[#ffdf07] text-sm sm:text-base md:text-lg font-semibold mb-4 libre-caslon-text-regular" data-id="element-105">
              For Healthcare Clinics Doing $3M–$25M+/Yr...
            </motion.p>
            {/* Main Headline */}
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.3
          }} className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-6 typekit-heading leading-tight px-2" data-id="element-106">
              Learn The Scaling Cheat Code Clinic Owners Use to Secure a{' '}
              <span className="relative inline-block" data-id="element-107">
                <span className="relative z-10 px-2 text-black font-bold" data-id="element-108">
                  Multi 8-Figure Payday
                </span>
                <motion.span initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 0.8,
                delay: 0.3,
                ease: 'easeOut'
              }} style={{
                transformOrigin: 'left'
              }} className="absolute inset-0 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] rounded-md shadow-[0_4px_14px_rgba(255,223,7,0.25)] z-0" data-id="element-109" />
              </span>
            </motion.h1>
            {/* Subheadline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.4
          }} className="libre-caslon-text-regular text-base sm:text-lg text-white mb-8 leading-relaxed px-2" data-id="element-110">
              Step 1: Tap play on the video below to learn how to avoid creating
              a business that never becomes an asset.
            </motion.p>
            {/* Wistia Video Player */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.6
          }} className="max-w-sm sm:max-w-md md:max-w-xl lg:max-w-3xl mx-auto mb-8" data-id="element-111">
              <div className="relative shadow-2xl rounded-lg overflow-hidden" data-id="element-112">
                <wistia-player media-id="9ccnfz42p2" aspect="1.7777777777777777" data-id="element-113"></wistia-player>
              </div>
            </motion.div>
            {/* Step 2 Text */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.7
          }} className="mb-6" data-id="element-114">
              <p className="libre-caslon-text-regular text-base sm:text-lg text-white leading-relaxed px-2" data-id="element-115">
                Step 2: Apply for the 8-Figure Clinic MRI
              </p>
            </motion.div>
            {/* Apply Button */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.8
          }} className="flex justify-center mb-4 mt-6" id="apply-button-section" data-id="element-116">
              <div className="relative" data-id="element-117">
                <div className="button-border-light" data-id="element-118"></div>
                <motion.button onClick={() => setShowModal(true)} whileHover={{
                scale: 1.05,
                boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
              }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 px-8 sm:px-10 rounded-md text-base shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-119">
                  Apply for the MRI Now
                </motion.button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Capacity Full Modal */}
      <AnimatePresence data-id="element-120">
        {showModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90" onClick={() => setShowModal(false)} data-id="element-121">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="relative w-full max-w-lg bg-gradient-to-b from-[#111111] to-[#0a0a0a] border border-[#ffdf07]/30 rounded-lg shadow-2xl p-8" onClick={e => e.stopPropagation()} data-id="element-122">
              <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-123">
                <XIcon size={24} data-id="element-124" />
              </button>

              <div className="text-center" data-id="element-125">
                <h2 className="typekit-heading text-2xl sm:text-3xl text-[#ffdf07] mb-4" data-id="element-126">
                  Capacity Completely Full
                </h2>
                <p className="libre-caslon-text-regular text-gray-300 text-base sm:text-lg leading-relaxed mb-6" data-id="element-127">
                  We are no longer accepting applications at this time as our
                  capacity is completely full.
                </p>
                <p className="libre-caslon-text-regular text-gray-300 text-base leading-relaxed mb-6" data-id="element-128">
                  If you'd like to be notified when spots become available,
                  please send an email to:
                </p>
                <a href="mailto:ivan@516partners.com" className="inline-block bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 px-6 rounded-md text-base shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] hover:scale-105 transition-transform duration-300" data-id="element-129">
                  ivan@516partners.com
                </a>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};
export default HeroSection;